import { useTheme, useMediaQuery } from '@mui/material'
import { TestStripFooter } from '../../../../../components/Footer'
import { useNavigate } from 'react-router'
import { SippLogoBlack } from '../../../../../components/icons'


export const ResultFooter = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const navigate = useNavigate()

  const handleRetakeAnalysis = () => {
    navigate('/test-strip/upload')
  }

  return (
    <TestStripFooter backgroundColor="transparent" isGlobal={false}>
      <></>
      {/* <Stack
        gap={2}
        alignItems="center"
        textAlign="center"
        direction={{xs: "column", md:"row"}}
        maxWidth={340}
        width="100%"
        p={3}
        sx={{
          backgroundColor: theme.palette.background.default,
          borderRadius: '0 0 24px 24px ',
          border: isMobile ? `1px solid ${theme.palette.grey[400]}` : 'none',
        }}
      >
        <OutlinedButton
          fullWidth
          size="large"
          onClick={handleRetakeAnalysis}
          startIcon={<RefreshIcon />}
          sx={{
            py: 1.5,
            px: isMobile ? '16px' : 4,
            backgroundColor: 'white',
            border: '1px solid #D0D5DD',
            color: 'primary.dark',
            order: isMobile ? 1 : 0,
          }}
        >
          Retake Analysis
        </OutlinedButton>
      </Stack> */}
    </TestStripFooter>
  )
}
